import type { CountryCode } from '@/types/country';

export const COUNTRIES: CountryCode[] = [
  'USA', // United States
  'GBR', // United Kingdom (UK)
  'AUS', // Australia
  'CAN', // Canada
  'FRA', // France
  'DEU', // Germany
  'EEA', // EU
  'IND', // India
  'GLO', // ALL (Global)
];

export const MSY_COUNTRIES: CountryCode[] = [
  'USA', // United States
  'GBR', // United Kingdom (UK)
  'AUS', // Australia
  'CAN', // Canada
  'FRA', // France
  'DEU', // Germany
  'IND', // India
  'ALL', // ALL (Global)
];

export const marketplaces = [
  {
    code: 'all',
    countries: [
      'USA',
      'GBR',
      'AUS',
      'CAN',
      'FRA',
      'DEU',
      'EEA',
      'IND',
      'GLO',
      'PHL', // keep extra at the end if present
    ],
    name: 'All',
  },
  {
    code: 'amazon',
    countries: [
      'USA',
      'GBR',
      'AUS',
      'CAN',
      'FRA',
      'DEU',
      'EEA',
      'GLO',
      'IND',
    ],
    name: 'Amazon',
  },
  {
    code: 'amazon_audible',
    countries: [
      'GLO',
    ],
    name: 'Amazon Audible',
  },
  {
    code: 'amazon_books',
    countries: [
      'GLO',
      'USA',
    ],
    name: 'Amazon Books',
  },
  {
    code: 'amazon_kindle',
    countries: [
      'GLO',
      'USA',
    ],
    name: 'Amazon Kindle',
  },
  {
    code: 'barnesandnoble',
    countries: [
      'GLO',
    ],
    name: 'Barnes & Noble',
  },
  {
    code: 'ebay',
    countries: [
      'USA',
      'GBR',
      'AUS',
      'CAN',
      'FRA',
      'DEU',
      'EEA',
      'IND',
      'GLO',
    ],
    name: 'eBay',
  },
  {
    code: 'etsy',
    countries: [
      'USA',
      'GBR',
      'AUS',
      'CAN',
      'FRA',
      'DEU',
      'EEA',
      'IND',
      'GLO',
    ],
    name: 'Etsy',
  },
  {
    code: 'facebook_marketplace',
    countries: ['USA'],
    name: 'Facebook',
  },
  {
    code: 'google_shopping',
    countries: ['USA'],
    name: 'Google Shopping',
  },
  {
    code: 'kobo',
    countries: ['USA'],
    name: 'Kobo',
  },
  {
    code: 'pinterest',
    countries: [
      'USA',
      'GBR',
      'FRA',
      'EEA',
      'PHL',
    ],
    name: 'Pinterest',
  },
  {
    code: 'shein',
    countries: ['GLO'],
    name: 'SHEIN',
  },
  {
    code: 'shopee',
    countries: ['GLO'],
    name: 'Shopee',
  },
  {
    code: 'shutterstock',
    countries: [
      'USA',
      'GBR',
      'AUS',
      'CAN',
      'FRA',
      'DEU',
      'EEA',
      'IND',
      'GLO',
    ],
    name: 'Shutterstock',
  },
  {
    code: 'target',
    countries: ['USA'],
    name: 'Target',
  },
  {
    code: 'teacherspayteachers',
    countries: ['USA'],
    name: 'TPT',
  },
  {
    code: 'temu',
    countries: ['GLO'],
    name: 'Temu',
  },
  {
    code: 'tiktok',
    countries: ['GLO'],
    name: 'TikTok',
  },
  {
    code: 'walmart',
    countries: [
      'USA',
      'CAN',
    ],
    name: 'Walmart',
  },
] satisfies {
  code: string;
  countries: CountryCode[];
  name: string;
}[];

export const mixPanelEvents = {
  ADDED_KEYWORD_TO_LIST: 'Added Keyword to List',
  CLICKED_CATEGORY_MODULE: 'Clicked Category Module',
  CLICKED_KEYWORD: 'Clicked Keyword',
  CLICKED_PAGINATION: 'Clicked Pagination',
  CLICKED_REGISTER_LINK: 'Clicked Register Link',
  CLICKED_DOWNGRADE: 'Clicked Downgrade',
  CLICKED_UPGRADE: 'Clicked Upgrade',
  CLICKED_ANALYZE: 'Clicked Analyze',
  CLICKED_BEST_SELLERS: 'Clicked Best Sellers',
  COPIED_KEYWORD: 'Copied Keyword',
  COPY_TO_CLIPBOARD: 'Copy to Clipboard',
  CREATED_KEYWORD_LIST: 'Created Keyword List',
  DRAGGED_KEYWORD_TO_LIST: 'Dragged Keyword to List',
  EXPORTED: 'Exported',
  FILTERED_KEYWORD: 'Filtered Keywords',
  OPENED_LISTING_BUILDER: 'Opened Listing Builder',
  HIT_QUOTA: 'Hit Quota',
  OPENED_KEYWORD_LIST_MODAL: 'Opened Keyword List Modal',
  PRINT: 'Print',
  SEARCHED_FOR_KEYWORD: 'Searched for Keyword',
  SEARCHED_FOR_SHOP: 'Searched for Shop',
  SORTED_BY_COLUMN: 'Sorted by Column',
  REMOVED_SEARCH_TERM: 'Removed Search Term',
  REMOVED_SEARCH_HISTORY: 'Removed Search History',
  APPLY_DASHBOARD_FILTER: 'Applied Dashboard Filter',
  CLICKED_DASHBOARD_MODULE: 'Clicked Dashboard Module',
  CLICKED_BLOG_ARTICLE_ON_DASHBOARD: 'Clicked Blog Article on Dashboard',
  CLICKED_PLAN_BUTTON: 'Clicked Plan Button',
  STARTED_CONNECTION_ON_DASHBOARD: 'Started Connection on Dashboard',
  COMPLETED_ETSY_CONNECTION_ON_DASHBOARD: 'Completed Etsy Connection on Dashboard',
  STARTED_GA4_CONNECTION_ON_DASHBOARD: 'Started GA4 Connection on Dashboard',
  COMPLETED_GA4_CONNECTION_ON_DASHBOARD: 'Completed GA4 Connection on Dashboard',
  CLICK_SECONDARY_BUTTON: 'Clicked Secondary Button',
  STARTED_SHOP_CONNECTION: 'Started Shop Connection',
  CLICK_CONNECT_SHOP_CANCEL_BUTTON: 'Clicked Connect Shop Cancel Button',
  REFUSED_ETSY_AUTHORIZATION: 'Refused Etsy Authorization',
  CANCELLED_AT_MODAL: 'Cancelled at Modal',
  CONNECTED_SHOP: 'Connected Shop',
  MOVED_DASHBOARD_MODULE: 'Moved Dashboard Module',
  MOVED_DASHBOARD_SCORECARDS_MODULE: 'Customize Dashboard',
  LOGGED_IN: 'Logged In',
  COMPLETED_REGISTRATION: 'Completed Registration',
  STARTED_ONBOARDING: 'Started Onboarding',
  CHANGE_AI_HELPER_LANGUAGE: 'Changed AI Helper Language',
  CLICKED_SYNC_NOW: 'Clicked Sync Now',
  VIEWED_CHANGE_EMAIL_PAGE: 'Viewed Change Email Magic Link Confirmation Page',
  USER_EMAIL_CONFIRMED: 'User Email Confirmed via Magic Link',
  RECEIVED_ERROR_ON_EMAIL_CONFIRMATION: 'Received Error on Email Confirmation',
  EDITED_MARKETPLACE: 'Edited Marketplace',
  EDITED_CATEGORY: 'Edited Category',
  PAGE_NOT_FOUND: 'Received Page Not Found',
  MOVED_TRAFFIC_STATS_MODULE: 'Moved Traffic Stats Module',
  MOVED_TRAFFIC__DEMOGRAPHIC_STATS_MODULE: 'Moved Traffic Stats Module - Demographic',
  CLICKED_CHANGE_PAYMENT_METHOD: 'Clicked Change Payment Method',
  OPEN_PAYPAL_CHANGE_PAYMENT_METHOD_DIALOG: 'Open PayPal Change Payment Method Dialog',
  ERROR_CHANGING_PAYMENT_METHOD: 'Error Changing Payment Method',
  CLICKED_CANCEL_SUBSCRIPTION: 'Clicked Cancel Subscription',
  OPEN_BASIC_RETIREMENT_DIALOG: 'Open Basic Retirement Dialog',
  CANCEL_SUBSCRIPTION_CANCELLED: 'Cancel Subscription Cancelled',
  CONFIRMED_CANCEL_BASIC_SUBSCRIPTION: 'Confirmed Cancel Basic Subscription',
  OPEN_EXIT_SURVEY_DIALOG: 'Open Exit Survey Dialog',
  CANCELLED_EXIT_SURVEY: 'Cancelled Exit Survey',
  CONFIRM_CANCEL_SUBSCRIPTION: 'Confirm Cancel Subscription',
  OPEN_CANCEL_SUBSCRIPTION_CONFIRMATION_DIALOG: 'Open Cancel Subscription Confirmation Dialog',
  CANCELLED_SUBSCRIPTION: 'Cancelled Subscription',
  ERROR_CANCEL_SUBSCRIPTION: 'Error Cancel Subscription',
  OPEN_EMAIL_CHANGE_DIALOG: 'Open Email Change Dialog',
  OPEN_PASSWORD_CHANGE_DIALOG: 'Open Password Change Dialog',
  ERROR_CHANGING_EMAIL: 'Error Changing Email',
  CHANGED_EMAIL: 'Changed Email',
  CLOSED_EMAIL_CHANGE_DIALOG: 'Closed Email Change Dialog',
  ERROR_CHANGING_PASSWORD: 'Error Changing Password',
  CHANGED_PASSWORD: 'Changed Password',
  CLOSED_PASSWORD_CHANGE_DIALOG: 'Closed Password Change Dialog',
  STARTED_GOOGLE_ACCOUNT_CONNECTION: 'Started Google Account Connection',
  STARTED_GOOGLE_ACCOUNT_DISCONNECTION: 'Started Google Account Disconnection',
  CONFIRMED_GOOGLE_ACCOUNT_DISCONNECTION: 'Confirmed Google Account Disconnection',
  SUBMITTED_GOOGLE_ACCOUNT_DISCONNECTION_EMAIL: 'Submitted Google Account Disconnection Email',
  ERROR_SUBMITTED_GOOGLE_ACCOUNT_DISCONNECTION_EMAIL: 'Error Submitted Google Account Disconnection Email',
  CLICKED_UPDATE_BILLING_INFORMATION: 'Clicked Update Billing Information',
  CONFIRMED_UPDATE_BILLING_INFORMATION: 'Confirmed Update Billing Information',
  CANCELLED_UPDATE_BILLING_INFORMATION: 'Cancelled Update Billing Information',
  CLICKED_VIEW_INVOICE: 'Clicked View Invoice',
  CLICKED_DOWNLOAD_INVOICE: 'Clicked Download Invoice',
  ERROR_DOWNLOADING_INVOICE: 'Error Downloading Invoice',
  CLOSED_INVOICE_DIALOG: 'Closed Invoice Dialog',
  CLICKED_CLOSE_ACCOUNT: 'Clicked Close Account',
  ERROR_DELETING_ACCOUNT: 'Error Deleting Account',
  CLICKED_NOTE_SAVE: 'Clicked Note Save',
  CLICKED_TRACKED_LISTING: 'Tracked Listing',
  CLICK_CUSTOMIZE_DASHBOARD: 'Clicked Customize Dashboard',
  CLOSE_CUSTOMIZE_DASHBOARD: 'Closed Customize Dashboard',
  SWITCH_SCORECARD_DASHBOARD: 'Switched on/off Dashboard Element',
  MOVED_DASHBOARD_SCORECARD: 'Moved Dashboard Scorecard',
  RESET_DEFAULT_CUSTOMIZE_DASHBOARD: 'Reset Dashboard Default',
  SHOP_TRACKED: 'Shop Tracked',
  SHOP_UNTRACKED: 'Shop Untracked',
  RECEIVED_ERROR: 'Received Error',
  CLICKED_ACHIEVEMENT_FILTER: 'Clicked Achievement Filter',
  LISTING_AUDIT_ETSY_THUMBNAIL_MISSING_IMAGE_URL: 'Listing Audit - Etsy Thumbnail Missing Image URL',
  DOWNLOADED_ACHIEVEMENT_BADGE: 'Downloaded Achievement Badge',
  OPTED_IN: 'Opted In',
  CLICK_REFRESH_LISTING: 'Clicked Refresh Listing',
  REFRESH_LISTING: 'Individual Listing Refreshed',
};

export const NEW_INPUT_COLORS = {
  white: '#ffffff',
  red: '#CC0100',
  tangerine: '#eb984e',
  yellow: '#F1C231',
  green: '#6AA84F',
  forestGreen: '#669286',
  blue: '#3C78D8',
  lightBlue: '#3D85C6',
  purple: '#674EA7',
  magenta: '#A64D79',
};

// TODO: Legacy colors, remove after migration
export const INPUT_COLORS = {
  white: '#ffffff',
  red: '#CC0100',
  oldRed: '#e12a29',
  tangerine: '#eb984e',
  oldTangarine: '#f363b1',
  yellow: '#F1C231',
  oldYellow: '#f9c754',
  green: '#6AA84F',
  oldGreen: '#329b72',
  forestGreen: '#669286',
  oldForestGreen: '#93ee81',
  blue: '#3C78D8',
  lightBlue: '#3D85C6',
  purple: '#674EA7',
  oldPurple: '#b242b6',
  magenta: '#A64D79',
};

export const DEFAULT_INPUT_COLOR = '#9CA3AF';

// TODO: Legacy colors, remove after migration
// Map new palette hex values to arrays that include their legacy hex counterparts.
// This allows filtering by a new color to match rows using either new or old stored hexes.
export const COLOR_HEX_ALIASES: Record<string, string[]> = {
  // New hex: [new, ...legacy]
  '#ffffff': ['#ffffff'],
  '#CC0100': ['#CC0100', '#e12a29'], // red, oldRed
  '#eb984e': ['#eb984e', '#f363b1'], // tangerine, oldTangarine
  '#F1C231': ['#F1C231', '#f9c754'], // yellow, oldYellow
  '#6AA84F': ['#6AA84F', '#329b72'], // green, oldGreen
  '#669286': ['#669286', '#93ee81'], // forestGreen, oldForestGreen
  '#3C78D8': ['#3C78D8'], // blue
  '#3D85C6': ['#3D85C6'], // lightBlue
  '#674EA7': ['#674EA7', '#b242b6'], // purple, oldPurple
  '#A64D79': ['#A64D79'], // magenta
  [DEFAULT_INPUT_COLOR]: [DEFAULT_INPUT_COLOR], // gray default
};

export const QUOTA_EXCEEDED_PAGES_INTEGRATED = ['competitor-sales', 'keyword-tool', 'rank-checker', 'shop-info', 'spotted-on-etsy'];
export const UPGRADE_BANNER_PAGES_INTEGRATED = ['keyword-tool', 'top-sellers', 'delivery-status', 'sales-map', 'shop-info', 'trend-buzz', 'competitor-sales', 'traffic-stats'];

export const bannerTextOptions = {
  listing_audit: {
    free: 'Want to run more Listing Audits today? Upgrade to a Pro or Expert plan to increase your daily audit limit and analyze more listings with deeper insights. Upgrade to keep optimizing without interruptions.',
    basic: 'Want to run more Listing Audits today? Upgrade to a Pro or Expert plan to increase your daily audit limit and analyze more listings with deeper insights. Upgrade to keep optimizing without interruptions.',
    pro: 'Want to run more Listing Audits today? Upgrade to a Expert plan to increase your daily audit limit and analyze more listings with deeper insights. Upgrade to keep optimizing without interruptions.',
    expert: 'Want to run more Listing Audits today? You\'re on an Expert plan, which already includes our highest standard daily audit limits. If you need higher limits or custom options, please contact our sales team.',
  },
};

export const tooltips = {
  free: 'Free members can run 5 Listing Audits per day. For higher daily limits, consider upgrading to an eRank Pro or Expert plan. All quotas reset at midnight EST.',
  pro: 'Pro members can run 200 Listing Audits per day. For higher daily limits, consider upgrading to an eRank Expert plan. All quotas reset at midnight EST.',
  basic: 'Basic members can run 50 Listing Audits per day. For higher daily limits, consider upgrading to an eRank Pro or Expert plan. All quotas reset at midnight EST.',
  expert: 'Expert members can run 500 Listing Audits per day. For higher daily limits, please contact our sales team. All quotas reset at midnight EST.',
};

export const INLINE_DATE_FILTER_PRESETS_DEFAULT = 'last_7_days';
export const INLINE_DATE_FILTER_PRESETS = [
  { label: 'Custom', value: 'custom' },
  { label: 'Last 7 Days', value: 'last_7_days' },
  { label: 'Last 14 Days', value: 'last_14_days' },
  { label: 'Last 30 Days', value: 'last_30_days' },
];
